import axios from 'axios'
import { message } from 'ant-design-vue'
// import store from '@/store'
import { getToken, getLKey, setLKey, removeToken } from '@/utils/auth'

let Message
const service = axios.create({
  // production
  // baseURL: process.env.NODE_ENV === 'development' ? '//192.168.3.12' : '//cgd-api.connectogether.cn', // url = base url + request url
  // baseURL: '//hswc-api.connectogether.cn', // url = base url + request url
  // baseURL: '//registration-api.redaward.cn', // url = base url + request url
  // baseURL: '//registration-api.xmgcd.xmcci.com',
  // baseURL: '//registration-api.fjuad.redaward.cn', // /*  */2025.6.12号切换
  baseURL: '//registration-api.zzdesign.org.cn', // 金主要的地址
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5 * 60 * 1000 // request timeout
})

service.interceptors.request.use(
  config => {
    if (config.url.indexOf('/orders/nomination/') === -1) {
      Message = message.loading({ content: 'loading...', key: 'message' })
    }
    config.headers['Authorization'] = getToken() || ''

    if (getLKey()) {
      config.headers['lang'] = getLKey()
    } else {
      setLKey('zh')
      config.headers['lang'] = 'zh'
    }

    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    Message()
    const { data } = response
    // if error
    return data
  },
  error => {
    Message()
    const { data, status } = error.response
    //  400表单错误 401token无效  422表达验证失败
    switch (status) {
      case 400: {
        message.error({ content: data.message, key: 'message', duration: 4 })
        break
      }
      case 401: {
        removeToken()
        location.href = '/'
        break
      }
      case 422: {
        message.error({ content: JSON.stringify(data.errors), key: 'message', duration: 4 })
        break
      }
    }
    return Promise.reject(error)
  }
)

export default service
